import api from './api.js'
import moment from 'moment'

const accountTypes = Object.freeze({
  TRIAL: 'trial',
  STANDARD: 'standard',
  RESELLER: 'reseller',
})

export const AccountType = {
  ...accountTypes,
  All: Object.values(accountTypes),
}
export const accountStatus = {
  EXPIRED: 'expired',
  DELETED: 'deleted',
}

export const ALL_MODULES = 'all'


export class Accounts
{
  static accounts = undefined
  static dirty = true

  static async Sync (expired) {
    if (!this.accounts || this.dirty) {
      this.accounts = await api.getAccounts(expired)
      this.dirty = false
    }
  }

  static SetDirty () {
    this.dirty = true
  }

  
  static Count () {
    if (!this.accounts) return -1
    return this.accounts.length
  }

  static async GetAll (expired = false) {
    await this.Sync(expired)
    return this.accounts
  }

  static Summarize (id, accountData) {
    const index = this.accounts.accounts.findIndex(x => x.id === id)
    
    const accountLine = {
      id: id,
      displayName: accountData.displayName,
      created: moment(accountData.created).toISOString(),
      expires: moment(accountData.expires).toISOString(),
      accountType: accountData.accountType,
      tag: accountData.tag,
      managingAccountID: accountData.managingAccountID,
    }
    // console.dir(accountLine)
    if (index === -1) {
      this.accounts.accounts.push(accountLine)
    } else {
      this.accounts.accounts[index] = accountLine
    }
  }


  static async Create (accountData) {
    const response = await api.createAccount(accountData)
    // console.log('create', JSON.stringify(response))
    this.Summarize(response.accountID, accountData)
    this.SetDirty()
    return response
  }

  static async Update (id, data) {
    const update = await api.updateAccount(id, data)
    // console.log('update', JSON.stringify(update))
    this.Summarize(id, data)
    this.SetDirty()
    return update
  }

  static async Delete (id) {
    // console.log(id)
    await api.deleteAccount(id)
    // remove account from cache
    const index = this.accounts.accounts.findIndex(x => x.id === id)
    if (index !== -1) {
      this.accounts.accounts.splice(index, 1)
    }
  }

  static async SoftDelete (id) {
    await api.softDeleteAccount(id)
  }

  static async RevertSoftDelete (id) {
    await api.revertSoftDeleteAccount(id)
  }

  static async Get (id) {
    return await api.getAccount(id)
  }
}
